import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-label"];
import ModuleIllustration from "@/shared/components/ModuleIllustration.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ErrorIllustration',
    props: {
        ariaLabel: { default: undefined }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                role: "img",
                "aria-label": __props.ariaLabel
            }, [
                _createVNode(ModuleIllustration, {
                    "icon-color": "#FF993E",
                    "glow-color": "var(--colors-warning-100)"
                })
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
